import { useDispatch } from 'react-redux';
import { useQuery } from '@zg-rentals/react-query5';
import { getDeclineReasons } from '../api';

export default function useGetDeclineReasons(useQueryOptions) {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ['getDeclineReasons'],
    queryFn: () => dispatch(getDeclineReasons()),
    ...useQueryOptions,
  });
}
